<main class="page-content">
    <ycn-page-toast-messages></ycn-page-toast-messages>

    @if (term) {
        <div class="page page-support">
            <div class="page-header page-header-support page-header-tall">
                <div class="container">
                    <div class="row">
                        <div class="col-auto">
                            <h1 class="page-title">Financial Glossary</h1>
                        </div>
                        <div class="col-auto">
                            <div class="form-inline">
                                <label class="form-label form-label-thin">Search</label>
                                <ycn-icon-search-autocomplete
                                    [appendToBody]="false"
                                    [placeholder]="'Search Term'"
                                    [searchType]="'glossary_term'"
                                    (submitHandler)="navigateToDefinitionPage($event.search_id)">
                                </ycn-icon-search-autocomplete>
                            </div>
                        </div>
                        <div class="col-12">
                            <a [href]="glossaryHomeUrl" class="page-header-navigation-inline">
                                <svg ycnIcon [name]="'icon-back'"></svg>
                                <span class="page-header-navigation-title">View All Terms</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="glossary-article page-body container">
                <div class="row">
                    <div class="col-9">
                        <h1 class="glossary-title">{{ term.name }} @if (term.status === 'draft') {<span class="text-blue"> (Draft)</span>} </h1>
            
                        @if (term.definition) {
                            <!-- TODO: Change to div when new definition admin widget is fully used-->
                            <p [innerHtml]="term.definition"></p>
                        }
            
                        @if (term.formula) {
                            <div class="glossary-subtitle">Formula</div>
                            <!-- TODO: Change to div when new formula admin widget is fully used-->
                            <p [innerHtml]="term.formula"></p>
                        }

                        @if (term.excelCode) {
                            <div class="glossary-subtitle">Excel Code</div>
                            <div [innerHtml]="term.excelCode"></div>
                        }
            
                        @if (sanitizedVideoLink) {
                            <div class="glossary-subtitle">Analysis Tutorial</div>
                            <div class="video-responsive" [innerHtml]="sanitizedVideoLink"></div>
                        }
                    </div>
                    <div class="col-3">
                        @if (relatedTerms.length > 0) {
                            <div class="glossary-sidebar">
                                <strong class="glossary-sidebar-title">Related Terms</strong>
                                @for(relatedTerm of relatedTerms; track relatedTerm.internalName) {
                                    <a class="glossary-sidebar-item"
                                        href="javascript:void(0)"
                                        (click)="navigateToDefinitionPage(relatedTerm.internalName)">{{ relatedTerm.name }}</a>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
</main>
